export default "_metastoreCSRFToken";